import React from 'react'
import PropTypes from 'prop-types'
import { links } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import InviteFriendBlock from 'components/_new/InviteFriendBlock/InviteFriendBlock'
import ContentWithLoader from 'components/loaders/ContentWithLoader/ContentWithLoader'

import BottomSection from './BottomSection/BottomSection'
import UpgradeSection from './UpgradeSection/UpgradeSection'
import HeroSection from '../components/HeroSection/HeroSection'
import TimerSection from '../components/TimerSection/TimerSection'
import ProductsSection from '../components/ProductsSection/ProductsSection'

import s from './Mobile.scss'


const Mobile = (props) => {
  const {
    messages, redirectLink, isUpgradable, isProductsSectionEnabled,
    hasLockedProductsAfterSubscription, email, isQueueFetched, isInviteFriendSectionEnabled,
  } = props

  const { heroSection, timerSection, upgradeSection, bottomSection } = messages

  return isProductsSectionEnabled ? (
    <div className={s.content}>
      <HeroSection messages={heroSection} email={email} />
      {
        !hasLockedProductsAfterSubscription && (
          <TimerSection messages={timerSection} />
        )
      }
      <ProductsSection redirectLink={links.queue} />
      {
        isInviteFriendSectionEnabled && (
          <Box mt="24">
            <InviteFriendBlock page="thank you" withLink />
          </Box>
        )
      }
      {
        isUpgradable && (
          <UpgradeSection messages={upgradeSection} redirectLink={redirectLink} />
        )
      }
      <BottomSection messages={bottomSection} redirectLink={redirectLink} />
    </div>
  ) : (
    <ContentWithLoader className={s.content} isFetching={!isQueueFetched}>
      <HeroSection messages={heroSection} email={email} />
      {
        isUpgradable && (
          <UpgradeSection messages={upgradeSection} redirectLink={redirectLink} />
        )
      }
      {
        isInviteFriendSectionEnabled && (
          <Box mt="24" pb="16">
            <InviteFriendBlock page="thank you" withLink />
          </Box>
        )
      }
      {
        !hasLockedProductsAfterSubscription && (
          <TimerSection messages={timerSection} />
        )
      }
      <BottomSection messages={bottomSection} redirectLink={redirectLink} />
    </ContentWithLoader>
  )
}

Mobile.propTypes = {
  email: PropTypes.string,
  redirectLink: PropTypes.string,
  isUpgradable: PropTypes.bool,
  isQueueFetched: PropTypes.bool,
  isProductsSectionEnabled: PropTypes.bool,
  hasLockedProductsAfterSubscription: PropTypes.bool,
}


export default Mobile
